import moment from "moment";
import { formatNumbers, formatedStatus } from "../helpers";

const STATUS_COLUMNS = ["status", "historyStatus"];
const DATE_COLUMNS = ["date", "created_at", "updated_at"];

// Mirrors DataTable.vue's per-cell display logic so exports match the on-screen table
export default function formatCell(row, col, rowIndex) {
  const value = row[col.column];

  if (col.column === "serial") return rowIndex + 1;
  if (col.column === "action" || col.column === "id") return "";
  if (col.formatAmount) return value ? "PKR " + formatNumbers(value) : "-";
  if (STATUS_COLUMNS.includes(col.column)) {
    return formatedStatus(value, col.userStatus, col.ledger) || "";
  }
  if (DATE_COLUMNS.includes(col.column) && value) {
    return moment(value).format("MMM D,YYYY hh:mm A");
  }
  return value === null || value === undefined ? "" : value;
}
